<template>
  <div class="consumer-manage-container">
    <!-- 顶部统计栏 -->
    <div class="statistic-bar">
      <el-card shadow="hover" class="stat-card">
        <div class="stat-item">
          <span class="stat-label">24小时内取消订单达到3次的消费者：</span>
          <span class="stat-count" @click="openMaliciousConsumerPage">
            {{ cancelOver3Count }}名
          </span>
        </div>
      </el-card>
    </div>

    <!-- 查询区域 -->
    <div class="search-area">
      <el-form
        :inline="true"
        :model="searchForm"
        label-width="100px"
        class="search-form"
      >
        <!-- openid查询 -->
        <el-form-item label="消费者openid">
          <el-input
            v-model="searchForm.openid"
            placeholder="请输入openid"
            clearable
            maxlength="50"
          ></el-input>
        </el-form-item>

        <!-- 注册手机号查询 -->
        <el-form-item label="注册手机号">
          <el-input
            v-model="searchForm.registeredMobile"
            placeholder="请输入注册手机号"
            clearable
            maxlength="11"
          ></el-input>
        </el-form-item>

        <!-- 微信名字查询 -->
        <el-form-item label="微信名字">
          <el-input
            v-model="searchForm.wechatName"
            placeholder="请输入微信名字"
            clearable
            maxlength="20"
          ></el-input>
        </el-form-item>

        <!-- 消费者状态查询 -->
        <el-form-item label="消费者状态">
          <el-select
            v-model="searchForm.consumerStatus"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="全部" value="" />
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="-1" />
          </el-select>
        </el-form-item>

        <!-- 注册时间范围 -->
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <!-- 查询/重置按钮 -->
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchConsumers"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 消费者表格 -->
    <div class="consumer-table">
      <el-table
        :data="consumerList"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载消费者数据中..."
        empty-text="暂无消费者数据"
        @sort-change="handleSortChange"
      >
        <!-- openid列 -->
        <el-table-column prop="openid" label="openid" width="280" />

        <!-- 注册手机号列 -->
        <el-table-column prop="registeredMobile" label="注册手机号" width="150">
          <template #default="{ row }">
            {{ formatPhone(row.registeredMobile) }}
          </template>
        </el-table-column>

        <!-- 微信名字列 -->
        <el-table-column prop="wechatName" label="微信名字" width="120" />

        <!-- 订单数列（支持排序） -->
        <el-table-column
          prop="orderCount"
          label="订单数"
          width="120"
          align="center"
          sortable
        />

        <!-- 注册时间列（支持排序） -->
        <el-table-column
          prop="registrationTime"
          label="注册时间"
          width="200"
          sortable
          :sort-method="sortByRegistrationTime"
        >
          <template #default="{ row }">
            {{ formatDateTime(row.registrationTime) }}
          </template>
        </el-table-column>

        <!-- 备注列 -->
        <el-table-column label="备注" width="260">
          <template #default="{ row }">
            <div class="remark-cell-container">
              <!-- 备注内容（有备注时显示） -->
              <div
                class="remark-content"
                v-if="row.consumerNotes && row.consumerNotes.trim()"
              >
                {{ row.consumerNotes }}
              </div>
              <!-- 备注按钮 -->
              <el-button
                type="text"
                @click="openRemarkDialog(row)"
                :style="{ color: row.consumerNotes ? '#409eff' : '#666' }"
                class="remark-btn"
              >
                {{ row.consumerNotes ? "编辑备注" : "添加备注" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <!-- 状态列 -->
        <el-table-column label="状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag
              :type="row.consumerStatus === '1' ? 'success' : 'danger'"
              size="medium"
              effect="plain"
            >
              {{ row.consumerStatus === "1" ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="160" fixed="right">
          <template #default="{ row }">
            <div class="action-buttons">
              <!-- 禁用/启用按钮 -->
              <el-button
                type="text"
                :style="{
                  color: row.consumerStatus === '1' ? '#f56c6c' : '#409eff',
                }"
                @click="
                  row.consumerStatus === '1'
                    ? openDisableDialog(row)
                    : openEnableDialog(row)
                "
              >
                {{ row.consumerStatus === "1" ? "禁用" : "启用" }}
              </el-button>

              <!-- 详情按钮 -->
              <el-button type="text" @click="viewConsumerDetails(row)">
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>

    <!-- 消费者备注弹窗 -->
    <el-dialog
      title="编辑消费者备注"
      :visible.sync="remarkDialogVisible"
      width="500px"
      center
      :before-close="handleRemarkDialogClose"
    >
      <div class="remark-dialog-content">
        <el-form :model="remarkForm" label-width="100px">
          <el-form-item label="备注内容" class="remark-input-item">
            <el-input
              type="textarea"
              rows="4"
              v-model="remarkForm.content"
              placeholder="请输入备注信息（例如：VIP客户、需优先服务等，最多500字符）"
              maxlength="500"
              show-word-limit
              clearable
            ></el-input>
            <div class="remark-tip">
              备注仅商家可见，用于记录消费者特殊需求、风控信息等
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-buttons">
          <el-button @click="remarkDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">保存备注</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 禁用确认弹窗 -->
    <el-dialog
      title="禁用消费者"
      :visible.sync="disableDialogVisible"
      width="400px"
      center
      :before-close="handleDialogClose"
    >
      <div class="disable-dialog-content">
        <p>确认禁用该消费者吗？禁用后消费者将无法正常下单。</p>
        <p class="warning-text">注：此操作不可逆，需手动启用才能恢复。</p>
        <div class="dialog-buttons">
          <el-button @click="disableDialogVisible = false">取消</el-button>
          <el-button type="danger" @click="handleDisable">确认禁用</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 启用确认弹窗（新增） -->
    <el-dialog
      title="启用消费者"
      :visible.sync="enableDialogVisible"
      width="400px"
      center
      :before-close="handleEnableDialogClose"
    >
      <div class="disable-dialog-content">
        <p>确认启用该消费者吗？启用后消费者可正常下单。</p>
        <p class="warning-text">注：此操作不可逆，需手动禁用才能限制。</p>
        <div class="dialog-buttons">
          <el-button @click="enableDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleEnableConfirm"
            >确认启用</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConsumerManage",
  data() {
    return {
      loading: false, // 加载状态
      consumerList: [], // 消费者列表
      pagination: {
        // 分页信息
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchForm: {
        // 查询表单
        openid: "",
        registeredMobile: "",
        wechatName: "",
        timeRange: [],
        consumerStatus: "",
      },
      cancelOver3Count: 2, // 24小时内取消3次订单的消费者数量
      sortBy: "registrationTime", // 默认排序字段
      sortOrder: "desc", // 默认排序方向（desc-倒序，asc-正序）
      remarkDialogVisible: false, // 备注弹窗显隐
      disableDialogVisible: false, // 禁用弹窗显隐
      enableDialogVisible: false, // 启用弹窗显隐（新增）
      currentConsumer: null, // 当前操作的消费者
      remarkForm: {
        // 备注表单
        consumerId: "",
        content: "",
      },
    };
  },
  mounted() {
    this.fetchConsumerList(); // 加载消费者列表
    this.fetchCancelOver3Count(); // 加载统计数据
  },
  methods: {
    // 1. 获取消费者列表（核心接口）
    async fetchConsumerList() {
      try {
        this.loading = true;
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }

        // 构建请求参数
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          openid: this.searchForm.openid.trim(),
          registeredMobile: this.searchForm.registeredMobile.trim(),
          wechatName: this.searchForm.wechatName.trim(),
          consumerStatus: this.searchForm.consumerStatus,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
        };

        // 处理时间范围
        if (this.searchForm.timeRange?.length === 2) {
          params.startTime = this.searchForm.timeRange[0];
          params.endTime = this.searchForm.timeRange[1];
        }

        // 过滤空参数
        Object.keys(params).forEach((key) => {
          if (
            params[key] === "" ||
            params[key] === null ||
            params[key] === undefined
          ) {
            delete params[key];
          }
        });

        // 发送请求
        const response = await this.$http.get("/api/merchant/consumers", {
          params,
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.code === 0) {
          const { consumers, pagination } = response.data.data;
          this.consumerList = consumers.map((consumer) => ({
            ...consumer,
            registeredMobile: consumer.registeredMobile || "未设置",
            wechatName: consumer.wechatName || "未知用户",
            orderCount: consumer.orderCount || 0,
            consumerNotes: consumer.consumerNotes || "",
          }));
          this.pagination = pagination;
        } else {
          throw new Error(response.data.message || "获取消费者列表失败");
        }
      } catch (error) {
        console.error("获取消费者列表异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error(
            error.message || "获取消费者数据失败，请稍后重试"
          );
          this.consumerList = [];
          this.pagination.total = 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 2. 获取24小时内取消3次订单的消费者数量
    async fetchCancelOver3Count() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }

        const response = await this.$http.get(
          "/api/merchant/consumers/cancel-over-3",
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.code === 0) {
          this.cancelOver3Count = response.data.data.count || 0;
        } else {
          throw new Error(response.data.message || "统计取消订单消费者失败");
        }
      } catch (error) {
        console.error("统计取消订单消费者异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error(error.message || "统计数据失败，默认显示0");
          this.cancelOver3Count = 0;
        }
      }
    },

    // 3. 搜索消费者（重置页码）
    searchConsumers() {
      this.pagination.currentPage = 1;
      this.fetchConsumerList();
    },

    // 4. 重置搜索条件
    resetSearch() {
      this.searchForm = {
        openid: "",
        registeredMobile: "",
        wechatName: "",
        timeRange: [],
        consumerStatus: "",
      };
      this.pagination.currentPage = 1;
      this.fetchConsumerList();
    },

    // 5. 表格排序变化
    handleSortChange({ prop, order }) {
      if (prop) {
        this.sortBy = prop;
        this.sortOrder = order === "ascending" ? "asc" : "desc";
      } else {
        this.sortBy = "registrationTime";
        this.sortOrder = "desc";
      }
      this.pagination.currentPage = 1;
      this.fetchConsumerList();
    },

    // 6. 注册时间排序（备用）
    sortByRegistrationTime(a, b) {
      const timeA = new Date(a.registrationTime).getTime();
      const timeB = new Date(b.registrationTime).getTime();
      return this.sortOrder === "asc" ? timeA - timeB : timeB - timeA;
    },

    // 7. 备注弹窗相关
    openRemarkDialog(consumer) {
      if (!consumer || !consumer._id) {
        this.$message.warning("无效的消费者数据");
        return;
      }
      this.currentConsumer = consumer;
      this.remarkForm = {
        consumerId: consumer._id,
        content: consumer.consumerNotes || "",
      };
      this.remarkDialogVisible = true;
    },

    async submitRemark() {
      try {
        const trimmedContent = this.remarkForm.content.trim();
        if (!this.remarkForm.consumerId) {
          this.$message.error("消费者ID缺失，无法保存");
          return;
        }
        if (trimmedContent.length > 500) {
          this.$message.error("备注内容不能超过500字符");
          return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }

        const response = await this.$http.put(
          `/api/merchant/consumers/${this.remarkForm.consumerId}/remark`,
          { consumerNotes: trimmedContent },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.code === 0) {
          this.$message.success("备注保存成功");
          this.remarkDialogVisible = false;
          this.fetchConsumerList();
        } else {
          throw new Error(response.data.message || "备注保存失败");
        }
      } catch (error) {
        console.error("提交备注异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else if (error.response?.status === 404) {
          this.$message.error("消费者不存在，无法保存备注");
        } else {
          this.$message.error(error.message || "备注保存失败，请稍后重试");
        }
      }
    },

    handleRemarkDialogClose() {
      this.currentConsumer = null;
      this.remarkForm = { consumerId: "", content: "" };
      this.remarkDialogVisible = false;
    },

    // 8. 禁用弹窗相关
    openDisableDialog(consumer) {
      this.currentConsumer = consumer;
      this.disableDialogVisible = true;
    },

    async handleDisable() {
      if (!this.currentConsumer) return;
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }

        await this.$http.put(
          `/api/merchant/consumers/${this.currentConsumer._id}/status`,
          { consumerStatus: "-1" },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        this.$message.success("消费者禁用成功");
        this.disableDialogVisible = false;
        this.fetchConsumerList();
        this.fetchCancelOver3Count();
      } catch (error) {
        console.error("禁用消费者异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error("消费者禁用失败，请稍后重试");
        }
      }
    },

    handleDialogClose() {
      this.currentConsumer = null;
    },

    // 9. 启用弹窗相关（新增）
    openEnableDialog(consumer) {
      this.currentConsumer = consumer;
      this.enableDialogVisible = true;
    },

    async handleEnableConfirm() {
      if (!this.currentConsumer) return;
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }

        await this.$http.put(
          `/api/merchant/consumers/${this.currentConsumer._id}/status`,
          { consumerStatus: "1" },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        this.$message.success("消费者启用成功");
        this.enableDialogVisible = false;
        this.fetchConsumerList();
      } catch (error) {
        console.error("启用消费者异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error("消费者启用失败，请稍后重试");
        }
      }
    },

    handleEnableDialogClose() {
      this.currentConsumer = null;
    },

    // 10. 查看消费者详情
    viewConsumerDetails(consumer) {
      if (!consumer || !consumer._id) {
        this.$message.warning("无效的消费者数据，无法查看详情");
        return;
      }
      const routeData = this.$router.resolve({
        name: "ConsumerDetails",
        params: { consumerId: consumer._id },
      });
      window.open(routeData.href, "_blank");
    },

    // 11. 打开恶意消费者页面
    openMaliciousConsumerPage() {
      const routeData = this.$router.resolve({ name: "MaliciousConsumer" });
      window.open(routeData.href, "_blank");
    },

    // 12. 分页相关
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchConsumerList();
    },

    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchConsumerList();
    },

    // 13. 格式化手机号（中间四位打码）
    formatPhone(phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.substring(0, 3) + "****" + phone.substring(7);
    },

    // 14. 格式化时间（ISO转本地时间）
    formatDateTime(isoString) {
      if (!isoString) return "无";
      const date = new Date(isoString);
      const localTime = new Date(date.getTime() + 8 * 60 * 60 * 1000);
      return localTime.toISOString().replace("T", " ").substring(0, 19);
    },
  },
};
</script>

<style scoped>
.consumer-manage-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 64px);
}

.statistic-bar {
  margin-bottom: 20px;
}

.stat-card {
  background-color: #f8f9fa;
  border: none;
}

.stat-item {
  font-size: 14px;
  color: #333;
}

.stat-count {
  color: #f56c6c;
  font-weight: 700;
  cursor: pointer;
  margin-left: 8px;
}

.stat-count:hover {
  text-decoration: underline;
}

.search-area {
  margin-bottom: 20px;
  background: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.consumer-table {
  margin-bottom: 20px;
}

.action-buttons {
  display: flex;
  justify-content: space-around;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.remark-dialog-content,
.disable-dialog-content {
  padding: 10px;
}

.dialog-buttons {
  margin-top: 20px;
  text-align: right;
}

.warning-text {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 8px;
}

/* 备注表单样式 */
.remark-input-item .el-form-item__label {
  width: 100px !important;
}

.remark-input-item .el-form-item__content {
  margin-left: 110px !important;
}

.remark-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}

/* 备注列单元格样式 */
.remark-cell-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 0;
}

.remark-content {
  font-size: 12px;
  color: #666;
  max-width: 240px;
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
  margin-bottom: 4px;
}

.remark-btn {
  padding: 0;
  font-size: 12px;
}
</style>